
import { buildRestApiUrl, getStandardHeaders } from '@/integrations/supabase/urlBuilder';
import { Courier } from '@/services/types/courierTypes';

// Оптимизированное получение полного списка курьеров с возможностью отмены запроса
export const fetchCouriersList = async (signal?: AbortSignal): Promise<Courier[]> => {
  try {
    console.log('Загружаем список всех курьеров');
    
    const url = buildRestApiUrl('couriers?select=id,name,phone,email,status,payment_method_id,card_last4,card_type,payment_updated_at&order=name.asc');
    
    const response = await fetch(url, {
      method: 'GET',
      headers: getStandardHeaders(),
      signal // Передаем сигнал для возможности отмены запроса
    });
    
    if (!response.ok) {
      console.error('Ошибка HTTP при загрузке курьеров:', response.status, response.statusText);
      throw new Error(`Не удалось загрузить курьеров: ${response.status} ${response.statusText}`);
    }
    
    const data = await response.json();
    console.log(`Загружено ${data.length} курьеров`);
    
    // Проверяем и нормализуем данные
    if (!Array.isArray(data)) {
      console.error('Ошибка: Полученные данные не являются массивом:', data);
      return [];
    }
    
    return data;
  } catch (error) {
    // Если это ошибка отмены запроса, пробрасываем её дальше
    if (error instanceof Error && error.name === 'AbortError') {
      console.log('Запрос курьеров был отменен');
      throw error;
    }
    
    console.error('Ошибка при загрузке списка курьеров:', error);
    return [];
  }
};

// Оптимизированное получение списка курьеров с платежными данными 
export const fetchCouriersWithPaymentData = async (signal?: AbortSignal): Promise<Courier[]> => {
  try {
    console.log('Загружаем курьеров с платежными данными');
    
    // Кешируем запрос для повышения производительности
    const cacheKey = 'couriers-with-payment-data';
    const cachedData = sessionStorage.getItem(cacheKey);
    
    if (cachedData) {
      try {
        const parsedData = JSON.parse(cachedData);
        const cacheTime = parsedData.timestamp;
        // Используем кеш если он не старше 5 минут
        if (cacheTime && Date.now() - cacheTime < 5 * 60 * 1000) {
          console.log('Используем кешированные данные для курьеров с платежными данными');
          return parsedData.data;
        }
      } catch (e) {
        console.error('Ошибка при разборе кешированных данных:', e);
      }
    }
    
    // Получаем всех курьеров
    const couriers = await fetchCouriersList(signal);
    
    // Фильтруем курьеров с платежными данными
    const filteredCouriers = couriers.filter(courier => 
      courier.payment_method_id || courier.card_last4
    );
    
    console.log(`Отфильтровано ${filteredCouriers.length} курьеров с платежными данными из ${couriers.length}`);
    
    // Кешируем результат
    try {
      sessionStorage.setItem(cacheKey, JSON.stringify({
        timestamp: Date.now(),
        data: filteredCouriers
      }));
    } catch (e) {
      console.error('Ошибка при кешировании данных:', e);
    }
    
    return filteredCouriers;
  } catch (error) {
    // Если это ошибка отмены запроса, пробрасываем её дальше
    if (error instanceof Error && error.name === 'AbortError') {
      console.log('Запрос курьеров с платежными данными был отменен');
      throw error;
    }
    
    console.error('Ошибка при загрузке курьеров с платежными данными:', error);
    return [];
  }
};
